import React, { useState, useEffect } from "react" ;

import UsersAppSidebar from "./Sidebar/PrivateMessagingAppSidebar";
import UsersAppBody from "./Body/PrivateMessagingAppBody";

const WieldyApplicationModulePrivateMessaging = (props) =>
{
    const [ height, setHeight ] = useState ( props.height ) ;
    const [ width, setWidth] = useState ( props.width ) ;
    const pageStyle = { height: '' + (+height-1) + 'px' } ;

    useEffect(() => {
        setHeight(props.height);
        setWidth(props.width);
    }, [props.height, props.width]);

    return (
        <div className="row">
            <div className="col-xl-12">

                <div className="dt-module" style={pageStyle}>

                    <UsersAppSidebar title={'Private Messaging'} iconName={'icon-files'} height={height} width={width}/>
                    <UsersAppBody height={height}/>
                    { /* <UsersAppDrawer /> */ }

                </div>
            </div>
        </div>
    );
}

export default WieldyApplicationModulePrivateMessaging;